export default function StatCard({ label, value, subtext, tone = "default" }) {
  return (
    <div className={`rounded-3xl p-4 md:p-5 ${tone === "dark" ? "bg-accent text-white" : "card-surface"}`}>
      <p className={`text-[10px] font-semibold uppercase tracking-[0.2em] ${tone === "dark" ? "text-white/60" : "text-slate-500"}`}>{label}</p>
      <p className={`mt-2 text-2xl font-semibold md:text-3xl ${tone === "dark" ? "text-white" : "text-accent"}`}>{value}</p>
      {subtext && <p className={`mt-1 text-xs ${tone === "dark" ? "text-white/60" : "text-slate-500"}`}>{subtext}</p>}
    </div>
  );
}
